export default {
  title: 'Wolt Drive onboarding',
  subtitle: 'Alleen zichtbaar voor onboardingmanagers.',
  steps: {
    request: {
      title: '1. Vraag de vestiging aan bij Wolt',
      description:
        'Kopieert de rij van dit restaurant voor het gedeelde Wolt-sheet. Plak het in kolom A van de eerstvolgende lege rij en laat het Wolt weten in het gezamenlijke Slack-kanaal.',
    },
    activate: {
      title: '2. Verifiëren en activeren',
      description:
        'Voer de vestigings-ID in die Wolt aan het sheet heeft toegevoegd. Deze wordt gecontroleerd met een testofferte van Wolt voordat er iets wordt opgeslagen.',
    },
  },
  fields: {
    venue_id: {
      label: 'Wolt-vestigings-ID',
      placeholder: 'bijv. 6736f9f5f9e2ab82f9150420',
      invalid: 'Een Wolt-vestigings-ID bestaat uit 24 tekens en gebruikt alleen 0–9 en a–f.',
    },
    priority: {
      label: 'Providerprioriteit',
      options: {
        wolt_primary: 'Wolt primair, huidige providers als terugval behouden',
        wolt_only: 'Alleen Wolt',
      },
    },
  },
  verification: {
    verified: 'Wolt heeft deze vestiging bevestigd.',
    failed: 'Wolt kon deze vestiging niet bevestigen.',
    wolt_reason: 'Wolt zei: {{reason}}',
    unavailable_now:
      'Wolt kan momenteel niet vanaf deze vestiging bezorgen ({{reason}}). U kunt dit nog steeds opslaan.',
  },
  preview: {
    label: 'Providervolgorde',
    none: 'geen',
  },
  hints: {
    internal_delivery:
      'Dit restaurant bezorgt met eigen bezorgers. Wolt wordt gebruikt zodra Bezorgmodus hieronder is ingesteld op externe bezorgers.',
    invalid_stored_id:
      'Het opgeslagen vestigings-ID {{venueId}} is geen geldig Wolt vestigings-ID, dus Wolt wordt niet gebruikt voor dit restaurant. Controleer en sla de juiste op.',
  },
  buttons: {
    copy_details: 'Gegevens kopiëren',
    verify: 'Verifiëren',
    save: 'Opslaan',
  },
  confirm: {
    title: 'Wolt Drive activeren?',
    description: 'Slaat vestigings-ID {{venueId}} op en wijzigt de providervolgorde naar: {{providers}}.',
    unsaved_providers: 'Niet-opgeslagen wijzigingen aan de onderstaande providerlijst worden vervangen.',
    ok: 'Opslaan',
    cancel: 'Annuleren',
  },
  toasts: {
    copied: 'Gekopieerd',
    copy_failed: 'Kon de gegevens niet kopiëren. Probeer het opnieuw.',
    saved: 'Wolt Drive is ingesteld voor dit restaurant.',
    save_failed: 'Kon niet opslaan. Probeer het opnieuw.',
  },
};
